import * as types from 'mutation-types'
import model from 'api'
import { setSessionStorage, getSessionStorage, clearSessionStorage } from 'utils/storage'

const state = {
  token: getSessionStorage('token') || '',
  user: getSessionStorage('user') || {},

  appDefault: {
    routeName: 'sn'
  }
}

const getters = {}

const mutations = {
  [types.SET_TOKEN] (state, token) {
    state.token = token
  },
  [types.SET_USER] (state, user) {
    state.user = user
  }
}

const actions = {
  async login ({ commit }, options) {
    const { token, user } = await model.App.login(options)
    commit(types.SET_TOKEN, token)
    setSessionStorage('token', token)
    commit(types.SET_USER, user)
    setSessionStorage('user', user)
  },
  async logout ({ commit }) {
    commit(types.SET_TOKEN, '')
    commit(types.SET_USER, '')
    clearSessionStorage()
  }
}

export default {
  state,
  getters,
  mutations,
  actions
}
